// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               unknown
// source: fight/model/enums/AmateurBoxingWeightClassPt.proto

/* eslint-disable */

export const protobufPackage = "io.teamsillim.fightbracket.idl.fight.model";

/**
 * 아마추어복싱 체급 (WBC 아마추어복싱 · KBF 대한복싱연맹)
 *
 * 중 · 고 · 일반부는 체급을 나누는 기준이 같아 체급표 한 장을 세 부가 함께 쓴다.
 * 남 · 여의 체급명이 같아도 상한 체중이 다르므로 성별까지 값에 담는다 (남 플라이급 -50kg, 여 플라이급 -51kg).
 * 초등부는 체급명 없이 체중 구간만 쓰고 성별을 나누지 않는다.
 */
export enum AmateurBoxingWeightClassPayload {
  AMATEUR_BOXING_WEIGHT_CLASS_UNKNOWN = 0,
  /** AMATEUR_BOXING_GENERAL_MALE_FLY - 중 · 고 · 일반부 남자 플라이급 (-50kg) */
  AMATEUR_BOXING_GENERAL_MALE_FLY = 1,
  /** AMATEUR_BOXING_GENERAL_MALE_BANTAM - 중 · 고 · 일반부 남자 밴텀급 (-55kg) */
  AMATEUR_BOXING_GENERAL_MALE_BANTAM = 2,
  /** AMATEUR_BOXING_GENERAL_MALE_LIGHT - 중 · 고 · 일반부 남자 라이트급 (-60kg) */
  AMATEUR_BOXING_GENERAL_MALE_LIGHT = 3,
  /** AMATEUR_BOXING_GENERAL_MALE_WELTER - 중 · 고 · 일반부 남자 웰터급 (-65kg) */
  AMATEUR_BOXING_GENERAL_MALE_WELTER = 4,
  /** AMATEUR_BOXING_GENERAL_MALE_LIGHT_MIDDLE - 중 · 고 · 일반부 남자 라이트미들급 (-70kg) */
  AMATEUR_BOXING_GENERAL_MALE_LIGHT_MIDDLE = 5,
  /** AMATEUR_BOXING_GENERAL_MALE_MIDDLE - 중 · 고 · 일반부 남자 미들급 (-75kg) */
  AMATEUR_BOXING_GENERAL_MALE_MIDDLE = 6,
  /** AMATEUR_BOXING_GENERAL_MALE_LIGHT_HEAVY - 중 · 고 · 일반부 남자 라이트헤비급 (-80kg) */
  AMATEUR_BOXING_GENERAL_MALE_LIGHT_HEAVY = 7,
  /** AMATEUR_BOXING_GENERAL_MALE_CRUISER - 중 · 고 · 일반부 남자 크루저급 (-85kg) */
  AMATEUR_BOXING_GENERAL_MALE_CRUISER = 8,
  /** AMATEUR_BOXING_GENERAL_MALE_HEAVY - 중 · 고 · 일반부 남자 헤비급 (-90kg) */
  AMATEUR_BOXING_GENERAL_MALE_HEAVY = 9,
  /** AMATEUR_BOXING_GENERAL_MALE_SUPER_HEAVY - 중 · 고 · 일반부 남자 슈퍼헤비급 (+90kg) */
  AMATEUR_BOXING_GENERAL_MALE_SUPER_HEAVY = 10,
  /** AMATEUR_BOXING_GENERAL_FEMALE_MINI_FLY - 중 · 고 · 일반부 여자 미니플라이급 (-48kg) */
  AMATEUR_BOXING_GENERAL_FEMALE_MINI_FLY = 11,
  /** AMATEUR_BOXING_GENERAL_FEMALE_FLY - 중 · 고 · 일반부 여자 플라이급 (-51kg) */
  AMATEUR_BOXING_GENERAL_FEMALE_FLY = 12,
  /** AMATEUR_BOXING_GENERAL_FEMALE_BANTAM - 중 · 고 · 일반부 여자 밴텀급 (-54kg) */
  AMATEUR_BOXING_GENERAL_FEMALE_BANTAM = 13,
  /** AMATEUR_BOXING_GENERAL_FEMALE_FEATHER - 중 · 고 · 일반부 여자 페더급 (-57kg) */
  AMATEUR_BOXING_GENERAL_FEMALE_FEATHER = 14,
  /** AMATEUR_BOXING_GENERAL_FEMALE_LIGHT - 중 · 고 · 일반부 여자 라이트급 (-60kg) */
  AMATEUR_BOXING_GENERAL_FEMALE_LIGHT = 15,
  /** AMATEUR_BOXING_GENERAL_FEMALE_WELTER - 중 · 고 · 일반부 여자 웰터급 (-65kg) */
  AMATEUR_BOXING_GENERAL_FEMALE_WELTER = 16,
  /** AMATEUR_BOXING_GENERAL_FEMALE_LIGHT_MIDDLE - 중 · 고 · 일반부 여자 라이트미들급 (-70kg) */
  AMATEUR_BOXING_GENERAL_FEMALE_LIGHT_MIDDLE = 17,
  /** AMATEUR_BOXING_GENERAL_FEMALE_MIDDLE - 중 · 고 · 일반부 여자 미들급 (-75kg) */
  AMATEUR_BOXING_GENERAL_FEMALE_MIDDLE = 18,
  /** AMATEUR_BOXING_GENERAL_FEMALE_LIGHT_HEAVY - 중 · 고 · 일반부 여자 라이트헤비급 (-80kg) */
  AMATEUR_BOXING_GENERAL_FEMALE_LIGHT_HEAVY = 19,
  /** AMATEUR_BOXING_GENERAL_FEMALE_HEAVY - 중 · 고 · 일반부 여자 헤비급 (+80kg) */
  AMATEUR_BOXING_GENERAL_FEMALE_HEAVY = 20,
  /** AMATEUR_BOXING_ELEMENTARY_22KG - 초등부 (-22kg) */
  AMATEUR_BOXING_ELEMENTARY_22KG = 21,
  /** AMATEUR_BOXING_ELEMENTARY_25KG - 초등부 (-25kg) */
  AMATEUR_BOXING_ELEMENTARY_25KG = 22,
  /** AMATEUR_BOXING_ELEMENTARY_27KG - 초등부 (-27kg) */
  AMATEUR_BOXING_ELEMENTARY_27KG = 23,
  /** AMATEUR_BOXING_ELEMENTARY_30KG - 초등부 (-30kg) */
  AMATEUR_BOXING_ELEMENTARY_30KG = 24,
  /** AMATEUR_BOXING_ELEMENTARY_32KG - 초등부 (-32kg) */
  AMATEUR_BOXING_ELEMENTARY_32KG = 25,
  /** AMATEUR_BOXING_ELEMENTARY_34KG - 초등부 (-34kg) */
  AMATEUR_BOXING_ELEMENTARY_34KG = 26,
  /** AMATEUR_BOXING_ELEMENTARY_36KG - 초등부 (-36kg) */
  AMATEUR_BOXING_ELEMENTARY_36KG = 27,
  /** AMATEUR_BOXING_ELEMENTARY_38KG - 초등부 (-38kg) */
  AMATEUR_BOXING_ELEMENTARY_38KG = 28,
  /** AMATEUR_BOXING_ELEMENTARY_40KG - 초등부 (-40kg) */
  AMATEUR_BOXING_ELEMENTARY_40KG = 29,
  /** AMATEUR_BOXING_ELEMENTARY_43KG - 초등부 (-43kg) */
  AMATEUR_BOXING_ELEMENTARY_43KG = 30,
  /** AMATEUR_BOXING_ELEMENTARY_46KG - 초등부 (-46kg) */
  AMATEUR_BOXING_ELEMENTARY_46KG = 31,
  /** AMATEUR_BOXING_ELEMENTARY_48KG - 초등부 (-48kg) */
  AMATEUR_BOXING_ELEMENTARY_48KG = 32,
  /** AMATEUR_BOXING_ELEMENTARY_50KG - 초등부 (-50kg) */
  AMATEUR_BOXING_ELEMENTARY_50KG = 33,
  /** AMATEUR_BOXING_ELEMENTARY_52KG - 초등부 (-52kg) */
  AMATEUR_BOXING_ELEMENTARY_52KG = 34,
  /** AMATEUR_BOXING_ELEMENTARY_54KG - 초등부 (-54kg) */
  AMATEUR_BOXING_ELEMENTARY_54KG = 35,
  /** AMATEUR_BOXING_ELEMENTARY_57KG - 초등부 (-57kg) */
  AMATEUR_BOXING_ELEMENTARY_57KG = 36,
  /** AMATEUR_BOXING_ELEMENTARY_OVER_57KG - 초등부 (+57kg) */
  AMATEUR_BOXING_ELEMENTARY_OVER_57KG = 37,
  UNRECOGNIZED = -1,
}

export function amateurBoxingWeightClassPayloadFromJSON(object: any): AmateurBoxingWeightClassPayload {
  switch (object) {
    case 0:
    case "AMATEUR_BOXING_WEIGHT_CLASS_UNKNOWN":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_WEIGHT_CLASS_UNKNOWN;
    case 1:
    case "AMATEUR_BOXING_GENERAL_MALE_FLY":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_MALE_FLY;
    case 2:
    case "AMATEUR_BOXING_GENERAL_MALE_BANTAM":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_MALE_BANTAM;
    case 3:
    case "AMATEUR_BOXING_GENERAL_MALE_LIGHT":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_MALE_LIGHT;
    case 4:
    case "AMATEUR_BOXING_GENERAL_MALE_WELTER":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_MALE_WELTER;
    case 5:
    case "AMATEUR_BOXING_GENERAL_MALE_LIGHT_MIDDLE":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_MALE_LIGHT_MIDDLE;
    case 6:
    case "AMATEUR_BOXING_GENERAL_MALE_MIDDLE":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_MALE_MIDDLE;
    case 7:
    case "AMATEUR_BOXING_GENERAL_MALE_LIGHT_HEAVY":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_MALE_LIGHT_HEAVY;
    case 8:
    case "AMATEUR_BOXING_GENERAL_MALE_CRUISER":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_MALE_CRUISER;
    case 9:
    case "AMATEUR_BOXING_GENERAL_MALE_HEAVY":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_MALE_HEAVY;
    case 10:
    case "AMATEUR_BOXING_GENERAL_MALE_SUPER_HEAVY":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_MALE_SUPER_HEAVY;
    case 11:
    case "AMATEUR_BOXING_GENERAL_FEMALE_MINI_FLY":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_FEMALE_MINI_FLY;
    case 12:
    case "AMATEUR_BOXING_GENERAL_FEMALE_FLY":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_FEMALE_FLY;
    case 13:
    case "AMATEUR_BOXING_GENERAL_FEMALE_BANTAM":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_FEMALE_BANTAM;
    case 14:
    case "AMATEUR_BOXING_GENERAL_FEMALE_FEATHER":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_FEMALE_FEATHER;
    case 15:
    case "AMATEUR_BOXING_GENERAL_FEMALE_LIGHT":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_FEMALE_LIGHT;
    case 16:
    case "AMATEUR_BOXING_GENERAL_FEMALE_WELTER":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_FEMALE_WELTER;
    case 17:
    case "AMATEUR_BOXING_GENERAL_FEMALE_LIGHT_MIDDLE":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_FEMALE_LIGHT_MIDDLE;
    case 18:
    case "AMATEUR_BOXING_GENERAL_FEMALE_MIDDLE":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_FEMALE_MIDDLE;
    case 19:
    case "AMATEUR_BOXING_GENERAL_FEMALE_LIGHT_HEAVY":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_FEMALE_LIGHT_HEAVY;
    case 20:
    case "AMATEUR_BOXING_GENERAL_FEMALE_HEAVY":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_FEMALE_HEAVY;
    case 21:
    case "AMATEUR_BOXING_ELEMENTARY_22KG":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_22KG;
    case 22:
    case "AMATEUR_BOXING_ELEMENTARY_25KG":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_25KG;
    case 23:
    case "AMATEUR_BOXING_ELEMENTARY_27KG":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_27KG;
    case 24:
    case "AMATEUR_BOXING_ELEMENTARY_30KG":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_30KG;
    case 25:
    case "AMATEUR_BOXING_ELEMENTARY_32KG":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_32KG;
    case 26:
    case "AMATEUR_BOXING_ELEMENTARY_34KG":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_34KG;
    case 27:
    case "AMATEUR_BOXING_ELEMENTARY_36KG":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_36KG;
    case 28:
    case "AMATEUR_BOXING_ELEMENTARY_38KG":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_38KG;
    case 29:
    case "AMATEUR_BOXING_ELEMENTARY_40KG":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_40KG;
    case 30:
    case "AMATEUR_BOXING_ELEMENTARY_43KG":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_43KG;
    case 31:
    case "AMATEUR_BOXING_ELEMENTARY_46KG":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_46KG;
    case 32:
    case "AMATEUR_BOXING_ELEMENTARY_48KG":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_48KG;
    case 33:
    case "AMATEUR_BOXING_ELEMENTARY_50KG":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_50KG;
    case 34:
    case "AMATEUR_BOXING_ELEMENTARY_52KG":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_52KG;
    case 35:
    case "AMATEUR_BOXING_ELEMENTARY_54KG":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_54KG;
    case 36:
    case "AMATEUR_BOXING_ELEMENTARY_57KG":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_57KG;
    case 37:
    case "AMATEUR_BOXING_ELEMENTARY_OVER_57KG":
      return AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_OVER_57KG;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AmateurBoxingWeightClassPayload.UNRECOGNIZED;
  }
}

export function amateurBoxingWeightClassPayloadToJSON(object: AmateurBoxingWeightClassPayload): string {
  switch (object) {
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_WEIGHT_CLASS_UNKNOWN:
      return "AMATEUR_BOXING_WEIGHT_CLASS_UNKNOWN";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_MALE_FLY:
      return "AMATEUR_BOXING_GENERAL_MALE_FLY";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_MALE_BANTAM:
      return "AMATEUR_BOXING_GENERAL_MALE_BANTAM";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_MALE_LIGHT:
      return "AMATEUR_BOXING_GENERAL_MALE_LIGHT";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_MALE_WELTER:
      return "AMATEUR_BOXING_GENERAL_MALE_WELTER";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_MALE_LIGHT_MIDDLE:
      return "AMATEUR_BOXING_GENERAL_MALE_LIGHT_MIDDLE";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_MALE_MIDDLE:
      return "AMATEUR_BOXING_GENERAL_MALE_MIDDLE";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_MALE_LIGHT_HEAVY:
      return "AMATEUR_BOXING_GENERAL_MALE_LIGHT_HEAVY";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_MALE_CRUISER:
      return "AMATEUR_BOXING_GENERAL_MALE_CRUISER";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_MALE_HEAVY:
      return "AMATEUR_BOXING_GENERAL_MALE_HEAVY";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_MALE_SUPER_HEAVY:
      return "AMATEUR_BOXING_GENERAL_MALE_SUPER_HEAVY";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_FEMALE_MINI_FLY:
      return "AMATEUR_BOXING_GENERAL_FEMALE_MINI_FLY";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_FEMALE_FLY:
      return "AMATEUR_BOXING_GENERAL_FEMALE_FLY";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_FEMALE_BANTAM:
      return "AMATEUR_BOXING_GENERAL_FEMALE_BANTAM";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_FEMALE_FEATHER:
      return "AMATEUR_BOXING_GENERAL_FEMALE_FEATHER";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_FEMALE_LIGHT:
      return "AMATEUR_BOXING_GENERAL_FEMALE_LIGHT";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_FEMALE_WELTER:
      return "AMATEUR_BOXING_GENERAL_FEMALE_WELTER";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_FEMALE_LIGHT_MIDDLE:
      return "AMATEUR_BOXING_GENERAL_FEMALE_LIGHT_MIDDLE";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_FEMALE_MIDDLE:
      return "AMATEUR_BOXING_GENERAL_FEMALE_MIDDLE";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_FEMALE_LIGHT_HEAVY:
      return "AMATEUR_BOXING_GENERAL_FEMALE_LIGHT_HEAVY";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_GENERAL_FEMALE_HEAVY:
      return "AMATEUR_BOXING_GENERAL_FEMALE_HEAVY";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_22KG:
      return "AMATEUR_BOXING_ELEMENTARY_22KG";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_25KG:
      return "AMATEUR_BOXING_ELEMENTARY_25KG";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_27KG:
      return "AMATEUR_BOXING_ELEMENTARY_27KG";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_30KG:
      return "AMATEUR_BOXING_ELEMENTARY_30KG";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_32KG:
      return "AMATEUR_BOXING_ELEMENTARY_32KG";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_34KG:
      return "AMATEUR_BOXING_ELEMENTARY_34KG";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_36KG:
      return "AMATEUR_BOXING_ELEMENTARY_36KG";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_38KG:
      return "AMATEUR_BOXING_ELEMENTARY_38KG";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_40KG:
      return "AMATEUR_BOXING_ELEMENTARY_40KG";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_43KG:
      return "AMATEUR_BOXING_ELEMENTARY_43KG";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_46KG:
      return "AMATEUR_BOXING_ELEMENTARY_46KG";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_48KG:
      return "AMATEUR_BOXING_ELEMENTARY_48KG";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_50KG:
      return "AMATEUR_BOXING_ELEMENTARY_50KG";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_52KG:
      return "AMATEUR_BOXING_ELEMENTARY_52KG";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_54KG:
      return "AMATEUR_BOXING_ELEMENTARY_54KG";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_57KG:
      return "AMATEUR_BOXING_ELEMENTARY_57KG";
    case AmateurBoxingWeightClassPayload.AMATEUR_BOXING_ELEMENTARY_OVER_57KG:
      return "AMATEUR_BOXING_ELEMENTARY_OVER_57KG";
    case AmateurBoxingWeightClassPayload.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
